import { logEvent } from './tracker';
import { parseEventName } from './eventName';
import { generateEventId } from './ids';
import type { LoggedEvent } from './types';

type TrackOptions = Pick<
  LoggedEvent,
  'metadata' | 'userId' | 'userEmail' | 'yearbookId' | 'brandId' | 'partnerId'
>;

export const trackOperation = async <T>(
  canonical: string,
  operation: () => Promise<T>,
  options: TrackOptions = {},
): Promise<T> => {
  const parsed = parseEventName(canonical);
  const correlationId = generateEventId();
  const start = performance.now();

  logEvent({
    ...parsed,
    ...options,
    correlationId,
    eventType: 'started',
    success: true,
  });

  try {
    const result = await operation();
    logEvent({
      ...parsed,
      ...options,
      correlationId,
      eventType: 'completed',
      success: true,
      metadata: {
        ...options.metadata,
        durationMs: Math.round(performance.now() - start),
      },
    });
    return result;
  } catch (err) {
    logEvent({
      ...parsed,
      ...options,
      correlationId,
      eventType: 'error',
      success: false,
      metadata: {
        ...options.metadata,
        errorMessage: err instanceof Error ? err.message : String(err),
      },
    });
    throw err;
  }
};
